import { useEffect, useState } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import { priceOptions, yesOrNoOptions } from "../../../../shared/utility";
import DocumentUi from "../../../importMedia/DocumentUi";

import Button from "../../../controls/Button";

const initialFValues = {
  name: "",
  taxes: [],
  customer_number: null,
  billing_and_shipping_address: null,
  active_status: { value: null },
  accounts_receivable: null,
};

export default function CustomerDetailsForm(props) {
  const {
    actionCall,
    customer,
    customerTypeOptions,
    isEdit,
    setOpen,
    taxRates,
    title,
  } = props;

  const [customerCert1, setCustomerCert1] = useState(null);
  const [customerCert2, setCustomerCert2] = useState(null);
  const [customerCert3, setCustomerCert3] = useState(null);

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall({
        ...values,
        customer_type: values.customer_type.value,
        taxes: values.taxes,
        active_status: values.active_status.value,
        price_option: values.price_option.value,
      });
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValues(customer);

      var customerTypeSelected = [];
      if (customer) {
        if (customer.customer_type) {
          customerTypeSelected = customerTypeOptions.find(
            (el) => el.value === customer.customer_type
          );

          if (typeof customerTypeSelected === "undefined") {
            customerTypeSelected = { value: null };
          }
        }
      }

      var activeStatusSelected = [];
      if (customer) {
        if (customer.active_status) {
          activeStatusSelected = yesOrNoOptions.find(
            (el) => el.value === customer.active_status
          );

          if (typeof activeStatusSelected === "undefined") {
            activeStatusSelected = { value: null };
          }
        }
      }

      var priceOptionSelected = [];
      if (customer) {
        if (customer.price_option) {
          priceOptionSelected = priceOptions.find(
            (el) => el.value === customer.price_option
          );

          if (typeof priceOptionSelected === "undefined") {
            priceOptionSelected = { value: null };
          }
        }
      }

      var taxRatesSelected = [];
      if (customer) {
        if (customer.taxRates) {
          taxRatesSelected = taxRates.filter((el) =>
            customer.taxRates.includes(el.value)
          );

          if (typeof taxRatesSelected === "undefined") {
            taxRatesSelected = { value: null };
          }
        }
      }

      setValues({
        ...customer,
        customer_type: customerTypeSelected,
        taxes: taxRatesSelected,
        active_status: activeStatusSelected,
        price_option: priceOptionSelected,
      });
    }
  }, [customer, setValues]);

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-5">
          <div className="grid grid-cols-2 gap-5">
            <Input
              label="Name"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Contact Name"
              name="contact_name"
              onChange={handleInputChange}
              value={values.contact_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Email"
              name="email"
              onChange={handleInputChange}
              value={values.email}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Phone"
              name="phone"
              onChange={handleInputChange}
              value={values.phone}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div className="grid grid-cols-3 gap-5">
            <Input
              label="Customer Number"
              name="customer_number"
              onChange={handleInputChange}
              value={values.customer_number}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="customer_type"
              options={customerTypeOptions}
              value={values.customer_type}
              title={"Type"}
              error={errors.customer_type}
              showLabel={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="taxes"
              options={taxRates}
              value={values.taxes}
              title={"Taxes"}
              error={errors.taxes}
              showLabel={true}
              isMulti={true}
            />
            <SelectMenu
              handleInputChange={handleInputChange}
              name="active_status"
              options={yesOrNoOptions}
              value={values.active_status}
              title={"Active Status"}
              error={errors.active_status}
              showLabel={true}
            />

            <SelectMenu
              handleInputChange={handleInputChange}
              name="price_option"
              options={priceOptions}
              value={values.price_option}
              title={"Price option"}
              error={errors.price_option}
              showLabel={true}
            />
            {/* <Input
              label="Accounts Receivable"
              name="accounts_receivable"
              onChange={handleInputChange}
              value={values.accounts_receivable}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            /> */}
          </div>
          <div>
            <p className="font-bold text-lg">Billing address</p>
            <div className="grid grid-cols-3 gap-5 mt-2">
              <Input
                label="Address 1"
                name="billing_address_1"
                onChange={handleInputChange}
                value={values.billing_address_1}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Address 2"
                name="billing_address_2"
                onChange={handleInputChange}
                value={values.billing_address_2}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Address 3"
                name="billing_address_3"
                onChange={handleInputChange}
                value={values.billing_address_3}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="City"
                name="billing_city"
                onChange={handleInputChange}
                value={values.billing_city}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Zip"
                name="billing_zip"
                onChange={handleInputChange}
                value={values.billing_zip}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="State"
                name="billing_state"
                onChange={handleInputChange}
                value={values.billing_state}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Country"
                name="billing_country"
                onChange={handleInputChange}
                value={values.billing_country}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
          </div>
          <div>
            <p className="font-bold text-lg">Shipping address</p>
            <div className="grid grid-cols-3 gap-5 mt-2">
              <Input
                label="Address 1"
                name="shipping_address_1"
                onChange={handleInputChange}
                value={values.shipping_address_1}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Address 2"
                name="shipping_address_2"
                onChange={handleInputChange}
                value={values.shipping_address_2}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Address 3"
                name="shipping_address_3"
                onChange={handleInputChange}
                value={values.shipping_address_3}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="City"
                name="shipping_city"
                onChange={handleInputChange}
                value={values.shipping_city}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Zip"
                name="shipping_zip"
                onChange={handleInputChange}
                value={values.shipping_zip}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="State"
                name="shipping_state"
                onChange={handleInputChange}
                value={values.shipping_state}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Country"
                name="shipping_country"
                onChange={handleInputChange}
                value={values.shipping_country}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2">
            <DocumentUi
              title="Certification 1"
              uploadedImage={customerCert1}
              setUploadedImage={setCustomerCert1}
              isEdit={isEdit}
              imageUrl={values.cert_1_url}
              imageName="cert_1"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_1: "",
                  cert_1_url: null,
                });
                setCustomerCert1(null);
              }}
              showNameInput={true}
              nameInput="cert_1_name"
              nameInputValue={values.cert_1_name}
            />
            <DocumentUi
              title="Certification 2"
              uploadedImage={customerCert2}
              setUploadedImage={setCustomerCert2}
              isEdit={isEdit}
              imageUrl={values.cert_2_url}
              imageName="cert_2"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_2: "",
                  cert_2_url: null,
                });
                setCustomerCert2(null);
              }}
              showNameInput={true}
              nameInput="cert_2_name"
              nameInputValue={values.cert_2_name}
            />
            <DocumentUi
              title="Certification 3"
              uploadedImage={customerCert3}
              setUploadedImage={setCustomerCert3}
              isEdit={isEdit}
              imageUrl={values.cert_3_url}
              imageName="cert_3"
              handleInputChange={handleInputChange}
              onDelete={() => {
                setValues({
                  ...values,
                  cert_3: "",
                  cert_3_url: null,
                });
                setCustomerCert3(null);
              }}
              showNameInput={true}
              nameInput="cert_3_name"
              nameInputValue={values.cert_3_name}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <Button variant="secondary" onClick={() => setOpen({ childComponent: null, open: false })}>Cancel</Button>
        <Button type="submit" className="ml-4" onClick={handleSubmit}>{isEdit ? "Save" : "Create"}</Button>
      </div>
    </form>
  );
}
